export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Shoes_BaseColor.dc648db0.tga";